import { ComponentType } from 'react';

import { styled } from '@mui/material/styles';

/**
 * HOC, который навешивает обязательные стили на Datagrid/DatagridConfigurable
 * для корректной работы sticky-тулбара внутри StickyContainerStyled.
 * Без этих стилей глобальные стили темы ломают позиционирование.
 */
export function withDatagridStickyStyles<P extends object>(Component: ComponentType<P>) {
  return styled(Component)({
    overflowX: 'visible',
    overflowY: 'visible',
    '& > div:has(> .MuiToolbar-root)': {
      position: 'static !important',
      top: 'auto !important',
      left: 'auto !important',
      zIndex: 'auto !important',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: 0,
      zIndex: 2,
    },
  });
}
